import React from 'react';
import PropTypes from 'prop-types';

const InfoPropTypes = {
  children: PropTypes.node,
};

const InfoDefaultProps = {
  children: null,
};

// eslint-disable-next-line react/destructuring-assignment
const Info = props => <div className="route__info">{props.children}</div>;

Info.propTypes = InfoPropTypes;

Info.defaultProps = InfoDefaultProps;

export default Info;
